import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { g as getLocale, o as transDialog, m as getTheme } from './utils2.js';

const mapyReviewTextareaCss = ":host{--resize:none;display:inline-flex;flex-direction:column;position:relative}textarea{font-family:Arial, Helvetica, sans-serif;font-size:14px;font-weight:400;line-height:20px;resize:var(--resize);border:1px solid #1eae00;border-radius:4px;padding:8px 12px;box-sizing:border-box}textarea:focus,textarea:active,textarea:hover{outline:0}textarea::placeholder{color:#828282}p{margin:0;font-family:Arial, Helvetica, sans-serif;font-size:12px;line-height:16px;color:#828282;position:absolute;left:12px;bottom:-4px;transform:translateY(100%)}strong{font-weight:700}textarea[data-theme=\"firmy\"]{border-color:#ccc}";
const MapyReviewTextareaStyle0 = mapyReviewTextareaCss;

const MapyReviewTextarea = /*@__PURE__*/ proxyCustomElement(class MapyReviewTextarea extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.change = createEvent(this, "change", 2);
        this.blurWithText = createEvent(this, "blurWithText", 2);
        this.handleInput = (event) => {
            const textarea = event.target;
            if (textarea && !textarea.disabled) {
                this.value = textarea.value;
                this.change.emit(this.value);
            }
        };
        this.onBlur = () => {
            if (this.value.length > 0) {
                this.blurWithText.emit({});
            }
        };
        this.value = "";
        this.maxLength = 0;
        this.lastLength = 0;
        this.height = 0;
        this.disabled = false;
        this.service = "mapy";
    }
    render() {
        const locale = getLocale(this.hostElement);
        const placeholder = this.service === "mapy"
            ? transDialog(locale, "textPlaceholder")
            : transDialog(locale, "textPlaceholderFirm");
        const style = {};
        const showCounter = (this.maxLength > 0 && this.lastLength === 0) || (this.lastLength > this.maxLength - this.value.length);
        if (this.height > 0) {
            style.height = `${this.height}px`;
        }
        return (h(Host, { key: '8c10becb928295aace142a79a3f3048d08351713' }, h("textarea", { key: '05b4e823c382bc587daf268a7d18c3defe1e28ee', style: style, disabled: this.disabled, placeholder: placeholder, onInput: this.handleInput, onChange: this.handleInput, onBlur: this.onBlur, "data-theme": getTheme(this.service), maxLength: this.maxLength }, this.value), showCounter
            ? h("p", { class: "counter", innerHTML: transDialog(locale, "numOfChar", { chars: this.maxLength - this.value.length }) })
            : null));
    }
    get hostElement() { return this; }
    static get style() { return MapyReviewTextareaStyle0; }
}, [1, "mapy-review-textarea", {
        "value": [513],
        "maxLength": [514, "max-length"],
        "lastLength": [514, "last-length"],
        "height": [514],
        "disabled": [516],
        "service": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-textarea"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-textarea":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewTextarea);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewTextarea as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-textarea2.js.map